import React from "react";
import Logo from "../../assets/images/logo.png";
import "./style.css";

const Navbar = () => {
  
  return (
    <div className="navbar-wrapper">
      <div style={{ display: "flex", alignItems: "center" }}>
        {/* <div
          className="toggle-menu-mobile"
          style={{ marginLeft: "24px" }}
          onClick={toggleSidebar}
        >
          <FontAwesomeIcon icon={faBars}></FontAwesomeIcon>
        </div> */}
        <div className="logo-wp">
          <img src={Logo} height="48px" alt="logo" />
        </div>
      </div>
    </div>
  );
};

export default Navbar;
